import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import browserHistory from 'react-router/lib/browserHistory';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import { actions as postDetailsActions } from '../../redux/communities/postDetails';
import { actions as postCommentActions } from '../../redux/communities/postComment';
import { actions as deleteCommentActions } from '../../redux/communities/deleteComment';
import { actions as editCommentActions } from '../../redux/communities/editComment';
import { actions as commentsListRequestActions } from '../../redux/communities/commentsListFetch';
import { actions as commentsListActions } from '../../redux/communities/commentsList';
import { loggedUserIdSelector } from '../../redux/context/selectors';
import { actions as deletePostActions } from '../../redux/communities/deletePost';
import { actions as editPostActions } from '../../redux/communities/editPost';
import { actions as currentCommunityActions } from '../../redux/communities/currentCommunity';
import { actions as currentCommunityInfoReq } from '../../redux/communities/currentCommunityInfo';
import {
  isCurrentCommunityModeratorSelector,
  currentCommunityInfoSelector,
} from '../../redux/communities/selectors/currentCommunity';
import { actions as reqSocialChannel } from '../../redux/board/reqSocialChannel';

import Loader from '../common/Loader';
import PostPreview from '../PostPreview';
import Comments from './Comments';
import AddComment from './AddComment';

import { COMMUNITIES, NOT_FOUND } from '../../constants/routes';
import {
  INFINITE_SCROLL_LOAD_EDGE_OFFSET,
  INFINITE_SCROLL_LOADER_HEIGHT,
} from '../../constants/chat';
import { COMMUNITIES_ACCESS_LEVELS } from '../../constants';

import InfiniteScroll from '../../utils/infiniteScroll';
import { isDesktop } from '../../utils/mobileHelpers';

import styles from './index.styl';

const mapStateToProps = state => ({
  postDetails: state.communities.postDetails,
  postsList: state.communities.postsList,
  commentsListRequest: state.communities.commentsList,
  currentUserId: loggedUserIdSelector(state),
  isModerator: isCurrentCommunityModeratorSelector(state),
  deletePostRequest: state.communities.deletePost,
  commentsList: state.communities.commentsList,
  currentCommunityInfo: currentCommunityInfoSelector(state),
});

const mapDispatchToProps = {
  getPostDetails: postDetailsActions.send,
  getComments: commentsListRequestActions.getComments,
  getOlderComments: commentsListRequestActions.getOlderComments,
  postComment: postCommentActions.send,
  deleteComment: deleteCommentActions.send,
  deletePost: deletePostActions.send,
  editPost: editPostActions.send,
  setCurrentCommunity: currentCommunityActions.set,
  clearComments: commentsListActions.clear,
  editComment: editCommentActions.send,
  createSocialChat: reqSocialChannel.send,
  currentCommunityInfoRequest: currentCommunityInfoReq.send,
};

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class Post extends Component {
  static propTypes = {
    routeParams: PropTypes.shape({
      communityId: PropTypes.string,
      postId: PropTypes.string,
    }).isRequired,
    postDetails: PropTypes.shape({
      sending: PropTypes.bool,
      succeed: PropTypes.bool,
      error: PropTypes.object,
      comments: PropTypes.array,
      id: PropTypes.number,
    }).isRequired,
    commentsListRequest: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.shape({
        sending: PropTypes.bool,
        succeed: PropTypes.bool,
        posts: PropTypes.array,
      }),
    ]).isRequired,
    getPostDetails: PropTypes.func.isRequired,
    getComments: PropTypes.func.isRequired,
    getOlderComments: PropTypes.func.isRequired,
    postComment: PropTypes.func.isRequired,
    deleteComment: PropTypes.func.isRequired,
    deletePostRequest: PropTypes.shape({
      sending: PropTypes.bool,
      succeed: PropTypes.bool,
    }).isRequired,
    currentUserId: PropTypes.number.isRequired,
    deletePost: PropTypes.func.isRequired,
    editPost: PropTypes.func.isRequired,
    setCurrentCommunity: PropTypes.func.isRequired,
    isModerator: PropTypes.bool,
    commentsList: PropTypes.array,
    clearComments: PropTypes.func.isRequired,
    editComment: PropTypes.func.isRequired,
    createSocialChat: PropTypes.func.isRequired,
    currentCommunityInfoRequest: PropTypes.func.isRequired,
    currentCommunityInfo: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isModerator: false,
    commentsList: [],
  };

  state = {
    state: null,
  };

  postRef = null;

  infiniteScroll = null;

  componentWillMount() {
    const {
      currentCommunityInfoRequest,
      setCurrentCommunity,
      routeParams,
    } = this.props;
    const { communityId } = routeParams;
    currentCommunityInfoRequest({ id: communityId });
    this.getDetails(this.props);
    this.fetchComments();
    setCurrentCommunity(+routeParams.communityId);
  }

  componentDidMount() {
    this.handleScrollPosition();
    this.initInfiniteScroll();
  }

  componentWillReceiveProps(nextProps) {
    const { deletePostRequest } = this.props;
    if (
      this.postDetailsReceivedOrChanged(nextProps) &&
      nextProps.postDetails.id
    ) {
      // while response has invalid key
      this.setState({ post: nextProps.postDetails });
    }

    if (
      deletePostRequest.sending &&
      !nextProps.deletePostRequest.sending &&
      nextProps.deletePostRequest.succeed
    ) {
      browserHistory.push(
        `/${COMMUNITIES}/${nextProps.routeParams.communityId}`,
      );
    }

    this.handleRequestErrors(nextProps);
  }

  componentWillUnmount() {
    const { clearComments } = this.props;
    this.unsubscribeInfiniteScroll();
    clearComments();
  }

  getDetails = props => {
    const posts = props.postsList;
    const { communityId, postId } = props.routeParams;

    // prerender with existed post data
    const post = posts && posts.find(item => item.id === +postId);
    this.setState({ post });

    // fetch details
    const { getPostDetails } = props;
    getPostDetails({
      communityId,
      postId,
    });
  };

  postDetailsReceivedOrChanged = nextProps => {
    const { postDetails: curDetails } = this.props;
    const { postDetails: nextDetails } = nextProps;

    return (
      (curDetails.sending && !nextDetails.sending && nextDetails.succeed) ||
      curDetails !== nextDetails
    );
  };

  handleScrollPosition = () => {
    const postElem = this.postRef;

    const wrapperElem = get(postElem, 'offsetParent');
    const wrapperItems = wrapperElem && wrapperElem.children;
    const scrolledElem =
      wrapperItems &&
      wrapperItems.length &&
      wrapperItems[wrapperItems.length - 1];

    if (scrolledElem) {
      scrolledElem.scrollTop = 0;
    }
  };

  fetchComments = () => {
    const {
      getComments,
      routeParams: { postId },
    } = this.props;

    getComments({ postId });
  };

  postComment = comment => {
    const { postComment } = this.props;
    postComment({
      postId: get(this.state, 'post.id'),
      ...comment,
    });
  };

  handleDeletePost = () => {
    const { routeParams, deletePost } = this.props;
    const { communityId, postId: id } = routeParams;

    deletePost({
      communityId,
      id,
    });
  };

  canDelete = post => {
    const { currentUserId, isModerator } = this.props;

    return isModerator || post.author.user.id === currentUserId;
  };

  handleEditPost = data => {
    const { editPost } = this.props;
    editPost(data);
  };

  canEdit = post => {
    const { currentUserId } = this.props;
    return post.author.user.id === currentUserId;
  };

  initInfiniteScroll = () => {
    const ref = isDesktop() ? 0 : 1;
    const element = get(this.postRef, `offsetParent.children[${ref}]`);

    this.infiniteScroll = new InfiniteScroll({
      element,
      loadEdgeOffset: INFINITE_SCROLL_LOAD_EDGE_OFFSET,
      loaderHeight: INFINITE_SCROLL_LOADER_HEIGHT,
      type: 'lower',
      onLoad: this.loadMore,
    });
  };

  loadMore = () => {
    const { post } = this.state;
    const { totalComments } = post;
    const {
      commentsList,
      routeParams: { postId },
      getOlderComments,
    } = this.props;

    const hasMore = totalComments > commentsList.length;

    if (hasMore) getOlderComments({ postId });
  };

  unsubscribeInfiniteScroll = () => {
    if (this.infiniteScroll) this.infiniteScroll.unsubscribe();
  };

  // comment menu section
  getCommentDeleteHandler = comment => {
    const {
      currentUserId,
      isModerator,
      deleteComment,
      postDetails,
    } = this.props;
    const canDelete =
      get(comment, 'author.user.id') === currentUserId || isModerator;

    return canDelete
      ? () =>
          deleteComment({
            postId: postDetails.id,
            id: comment.id,
            parentId: comment.parentId,
          })
      : null;
  };

  getCommentEditHandler = comment => {
    const { currentUserId, editComment, postDetails } = this.props;
    const canEdit = get(comment, 'author.user.id') === currentUserId;

    return canEdit
      ? content =>
          editComment({
            postId: postDetails.id,
            id: comment.id,
            parentId: comment.parentId,
            content,
          })
      : null;
  };

  handleRequestErrors = nextProps => {
    const { sending, error } = nextProps.postDetails;
    const { postDetails } = this.props;

    if (postDetails.sending && !sending && error) {
      const { status } = error;

      if (status === 404) {
        return browserHistory.push(NOT_FOUND);
      }
    }
  };

  handleStartConversation = authorId => {
    const { createSocialChat } = this.props;
    createSocialChat({ participants: [authorId] });
  };

  // end
  render() {
    const {
      commentsListRequest,
      commentsList,
      currentUserId,
      currentCommunityInfo,
      isModerator,
      routeParams,
    } = this.props;

    const { communityId } = routeParams;
    const { sending: commentsLoading } = commentsListRequest;
    const { post } = this.state;

    const hasComments = commentsList && commentsList.length > 0;
    const accessLevel = get(currentCommunityInfo, 'accessLevel');
    const currentUserRole = get(currentCommunityInfo, 'currentUserRole');
    const canComment =
      isModerator || accessLevel !== COMMUNITIES_ACCESS_LEVELS.READ_ONLY;

    return (
      <div ref={node => (this.postRef = node)}>
        <Choose>
          <When condition={!post}>
            <Loader />
          </When>
          <Otherwise>
            <PostPreview
              {...post}
              communityId={communityId}
              onDelete={
                this.canDelete(post)
                  ? () => this.handleDeletePost(post.id)
                  : null
              }
              onEdit={this.canEdit(post) ? this.handleEditPost : null}
              currentUserRole={currentUserRole}
            />
            {/* TODO: add activity for the new notifications */}
            <If condition={commentsLoading}>
              <Loader />
            </If>
            <If condition={currentUserRole && canComment}>
              <AddComment onSubmit={content => this.postComment({ content })} />
            </If>
            <If condition={hasComments}>
              <Comments
                total={post.totalComments}
                list={commentsList}
                onReply={comment => this.postComment(comment)}
                getCommentDeleteHandler={this.getCommentDeleteHandler}
                getCommentEditHandler={this.getCommentEditHandler}
                onRequestConversation={this.handleStartConversation}
                loggedUserId={currentUserId}
                canComment={canComment}
              />
            </If>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}
/* eslint-enable no-unused-expressions */



// WEBPACK FOOTER //
// ./src/components/Post/index.jsx